import { Component, OnInit } from "@angular/core";

@Component({
    selector: "poweredby-logo",
    templateUrl: "./poweredby-logo.component.svg",
    styleUrls: ["./poweredby-logo.component.scss"]
})
export class PoweredbyLogoComponent {
    constructor() {}
}
